export type OrganizationPayFee = {
  id: string
  organizationId: string
  feeSource: FeeSource
  feeType: FeeType
  feeAmount: number
  updatedAt: string
  updatedByName: string
  updatedReason: string
}

export enum FeeSource {
  CONVERSION = 'CONVERSION',
  TRANSFER = 'TRANSFER',
}

export enum FeeType {
  FIXED = 'FIXED',
  PERCENTAGE = 'PERCENTAGE',
}

export type Fee = {
  source: FeeSource
  type: FeeType
  amount: number
}

export type FeePayload = {
  // when undefined system default fees will be used
  id?: string
  feeSource: FeeSource
  feeType: FeeType
  feeAmount: number
}

export type UpdateOrganizationPayFeesBody = {
  fees: {
    feeSource: FeeSource
    feeType: FeeType
    feeAmount: number
    updatedByName: string
    updatedReason: string
  }[]
}

export type OrganizationFeeWithDefault = {
  id?: string // undefined if using system default
  feeSource: FeeSource
  feeType: FeeType
  feeAmount: number
  globalDefault: {
    feeType: FeeType
    feeAmount: number
  }
  isOverride: boolean // true if org has custom value
  updatedAt?: string
  updatedByName?: string
  updatedReason?: string
}

export type OrganizationFeesPayload = {
  organizationId: string
  fees: OrganizationFeeWithDefault[]
}

export type SystemFeesPayload = {
  fees: FeePayload[]
}
